
import React from 'react';
import { FormattedMessage } from 'react-intl';
import 'react-table-6/react-table.css';
import PasswordHeader from './components/Password/PasswordHeader';
import PasswordCell from './components/Password/PasswordCell';
import OwnedCell from './components/OwnedCell';
import UsernameCell from './components/UsernameCell';
import SelectedCell from './components/SelectedCell/SelectedCell';
import LinkedVulns from './components/LinkedVulns';
import LeakDateCell from './components/LeakDateCell';

export default function getColumns (hidePass, setHidePass, isFetching) {
  const columns = [
    {
      Header: () => (<SelectedCell isHeader />),
      id: 'selected',
      accessor: 'Selected',
      show: true,
      sortable: false,
      resizable: false,
      maxWidth: 55,
      minWidth: 55,
      headerStyle: { overflow: 'visible' },
      style: { display: 'flex' },
      Cell: (rowInfo) => <SelectedCell rowInfo={ rowInfo } showSkeleton={ isFetching } />
    }, {
      Header: () => (<FormattedMessage id="credentials.table.columns.endpoint" />),
      id: 'endpoint',
      accessor: 'endpoint',
      show: true,
      sortable: true,
      resizable: true,
      maxWidth: 187,
      minWidth: 187,
      headerStyle: { overflow: 'visible' },
      style: { display: 'flex' },
      Cell: (rowInfo) => <UsernameCell showSkeleton={ isFetching } rowInfo={ rowInfo } field={ 'endpoint' } />
    }, {
      Header: () => (<FormattedMessage id="credentials.table.columns.username" />),
      id: 'username',
      accessor: 'username',
      show: true,
      sortable: true,
      resizable: true,
      maxWidth: 201,
      minWidth: 201,
      headerStyle: { overflow: 'visible' },
      style: { display: 'flex' },
      Cell: (rowInfo) => <UsernameCell showSkeleton={ isFetching } rowInfo={ rowInfo } field={ 'username' } />
    }, {
      Header: () => (<PasswordHeader hidePass={ hidePass } setHidePass={ setHidePass } />),
      id: 'password',
      accessor: 'password',
      show: true,
      sortable: !hidePass,
      resizable: true,
      maxWidth: 177,
      minWidth: 177,
      headerStyle: { overflow: 'visible' },
      style: { display: 'flex' },
      Cell: (rowInfo) => <PasswordCell showSkeleton={ isFetching } rowInfo={ rowInfo } field={ 'password' } hidePass={ hidePass } />
    }, {
      Header: () => (<FormattedMessage id="credentials.table.columns.linkedVulnerability" />),
      id: 'linked_vulnerability',
      accessor: 'linked_vulnerability',
      show: true,
      sortable: false,
      resizable: true,
      maxWidth: 249,
      minWidth: 249,
      headerStyle: { overflow: 'visible' },
      style: { display: 'flex' },
      Cell: (rowInfo) => <LinkedVulns showSkeleton={ isFetching } rowInfo={ rowInfo } />
    }, {
      Header: () => (<FormattedMessage id="credentials.table.columns.owned" />),
      id: 'owned',
      accessor: 'owned',
      show: true,
      sortable: true,
      resizable: false,
      maxWidth: 157,
      minWidth: 157,
      headerStyle: { overflow: 'visible' },
      style: { display: 'flex' },
      Cell: (rowInfo) => <OwnedCell showSkeleton={ isFetching } rowInfo={ rowInfo } field={ 'owned' } />
    }, {
      Header: () => (<FormattedMessage id="credentials.table.columns.leakDate" />),
      id: 'leak_date',
      accessor: 'leak_date',
      show: true,
      sortable: true,
      resizable: false,
      headerStyle: { overflow: 'visible' },
      style: { display: 'flex' },
      Cell: (rowInfo) => <LeakDateCell showSkeleton={ isFetching } rowInfo={ rowInfo } />
    }
  ];

  const ordered_columns = columns
    .map(column => ({
      ...column,
      // Using !column.custom_order could cause problems due to how javascript handles false values. For example, if custom_order is 0
      custom_order: typeof column.custom_order === 'undefined' ? 0 : column.custom_order
    }))
    .filter((row, index) => row.show === true || index === 0)
    .sort((a, b) => a.custom_order - b.custom_order);
  return ordered_columns;
}
